export const phaseMultiplier = {
  'LIQUID': 1867.7/0.46177685260772705, // 36 RIG on AM-528g
  'GASEOUS': 307.86/0.13899332284927368, // 23 COL on CG-339b
  'MINERAL': 1009.31/0.5989084839820862, // 15 EXT on AW-284f
};
